import { httpV2 } from "@/api";

/**
 * @summary Obtém as preferências de um usuário.
 * @param {string} userId Id do usuário.
 * @returns {Object} Objeto com as preferências de um usuário.
 */
const GetUserPreferences = function(userId)
{
	return httpV2.get(`/UserPreferences/${userId}`);
};

/**
 * @summary Atualiza as preferências de um usuário.
 * @param {string} userId Id do usuário.
 * @param {object} profilePreferences Informações de preferências do usuário.
 * @returns {Promise} Promise.
 */
const UpdateUserPreferences = function(userId, profilePreferences)
{
	return httpV2.put(`/UserPreferences/${userId}`, profilePreferences);
};

/**
 * @summary Atualizar uma ou mais preferências de um usuário.
 * @param {string} userId Id do usuário.
 * @param {object} profilePreferences Informações de preferências do usuário.
 * @returns {Promise} Promise.
 */
const PatchUserPreferences = function(userId, preferences)
{
	const params = {
		theme:    "",
		language: "",
		timeZone: "",
	};

	params.theme = preferences.theme;
	params.language = preferences.language;
	params.timeZone = preferences.timeZone;

	return httpV2.patch(`/UserPreferences/${userId}`, params);
};

export default {
	GetUserPreferences,
	UpdateUserPreferences,
	PatchUserPreferences,
};
